module.exports = __webpack_public_path__ + "img/ani.963854d5.png";